(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('NotificationsController', NotificationsController);

  /* ngInject */
  function NotificationsController($state, $stateParams, Flash, assessmentEvents, assessmentService, contractEvents, contractService, documentRequirementService, documentRequirementEvents, notificationService, sessionService, vmsUserService, vendorService)  {
    const vm = this;

    vm.createNotification = createNotification;
    vm.deleteNotification = deleteNotification;
    vm.events = [];
    vm.eventTypes = [];
    vm.id = $stateParams.id;
    vm.notifiableType = $stateParams.notifiable_type;
    vm.notifiable = {};
    vm.notifications = [];
    vm.notificationEvents = [];
    vm.users = [];
    vm.vendor = {};
    vm.vendorId = $stateParams.vendorId;

    activate();

    function activate() {
      getNotifications();
      getResource();
      getUsers();
      getVendor();
      setEventTypes();
    }

    function createNotification() {
      var body = {
        'notification': vm.notification,
        'events': vm.events
      };

      notificationService(sessionService.getAuthToken()).create(notifiableParams(), body,
        _ => {
          $state.reload();
          Flash.create('success', 'Notification successfully created.');
        },
        _ => {
          Flash.create('danger', 'An error occurred with the submission. Please try again later.');
        }
      );
    }

    function deleteNotification(id) {
      notificationService(sessionService.getAuthToken()).destroy({ id: id },
        _ => {
          $state.reload();
          Flash.create('success', 'Notification successfully deleted.');
        },
        _ => {
          Flash.create('danger', 'An error occurred with the submission. Please try again later.');
        }
      );
    }

    function getNotifications() {
      var params = notifiableParams();
      notificationService(sessionService.getAuthToken()).query(params, response => vm.notifications = response);
    }

    function notifiableParams() {
      var params = {};

      if (vm.notifiableType == 'assessment') {
        params['vendor_id'] = vm.vendorId;
      } else if (vm.notifiableType == 'contract') {
        params['contract_id'] = vm.id;
      } else if (vm.notifiableType == 'document_requirement') {
        params['document_requirement_id'] = vm.id;
      }

      return params;
    }

    function getResource() {
      if (vm.notifiableType == 'assessment') {
        assessmentService(sessionService.getAuthToken()).get({ vendor_id: vm.vendorId, id: vm.id }, response => vm.notifiable = response);
      } else if (vm.notifiableType == 'contract') {
        contractService(sessionService.getAuthToken()).get({ id: vm.id }, response => vm.notifiable = response);
      } else if (vm.notifiableType == 'document_requirement') {
        documentRequirementService(sessionService.getAuthToken()).get({ vendorId: vm.vendorId, id: vm.id }, response => vm.notifiable = response);
      }
    }

    function getUsers() {
      vmsUserService(sessionService.getAuthToken()).query(response => vm.users = response);
    }

    function getVendor() {
      vendorService(sessionService.getAuthToken()).get({ id: vm.vendorId }, response => vm.vendor = response);
    }

    function setEventTypes() {
      if (vm.notifiableType == 'document_requirement') {
        vm.eventTypes = documentRequirementEvents;
      } else if (vm.notifiableType == 'contract') {
        vm.eventTypes = contractEvents;
      } else if (vm.notifiableType == 'assessment') {
        vm.eventTypes = assessmentEvents;
      }
    }
  }
})();
